import { useAuth } from "../hooks/useAuth";
import DrawerItems from "./DrawerItem";

// SIM
// TCU
// USER
// VEHICLE
// DEALER
// VIN-JOURNEY
// KYC-PROCESSING
// KYC-DETAILS
// DEALER-TICKETS
// VIN-IMEI-LOGS
// KYC-LOGS
// EOLT-REPORT
// CERTIFICATE-MANAGER
// CERTIFICATE-VIEWER
// CERTIFICATE-EXPIRY
// AIS-TICKETS
// NEFT-PAYMENT
// PAYMENTS
// SUPPORT-CONTACT

/** Maps drawer keys to their required feature names (any one of them grants access) */
export const featureMap: Record<string, string[]> = {
  "device-manager": ["TCU"],
  "sim-management": ["SIM"],
  "dealers": ["DEALER"],
  "vin-journey": ["VEHICLE", "KYC-PROCESSING"],
  "certificate-manager": ["CERTIFICATE-MANAGER", "CERTIFICATE-VIEWER"],
  "certificate-expiry": ["CERTIFICATE-EXPIRY"],
  "kyc-details": ["KYC-DETAILS"],
  "user-management": ["USER"],
  "eolt-reports": ["EOLT-REPORT"],
  "ais-tickets": ["AIS-TICKETS"],
  "dealer-tickets": ["DEALER-TICKETS"],
  "vin-imei-logs": ["VIN-IMEI-LOGS","KYC-LOGS"],
  "neft-kyc": ["NEFT-PAYMENT"],
  "payments": ["PAYMENTS"],
  "support-contact": ["SUPPORT-CONTACT"],
  "pd-cases": ["PD-CASE"],
  "bootstrap-extension": ["BOOTSTRAP-EXTENSION"],
  account: [], // Empty array means public
};

/** Filters drawer items based on active features from auth context */
export const useFilteredDrawerItems = () => {
  const { hasFeature } = useAuth();

  return DrawerItems.filter((item: { key: string | number }) => {
    if (item.key === "account") return true;
    const requiredFeatures = featureMap[item.key];

    // If item is not in map, assume it's protected and hide it
    if (requiredFeatures === undefined) return false;

    // If mapped to an empty array (or empty string in previous version), it's public (like Account)
    if (requiredFeatures.length === 0) return true;

    // Show if user has ANY of the required features
    return requiredFeatures.some((feature) => hasFeature(feature));
  });
};
